import { baseService } from "cortex/ui/src/service/base";

interface EventFilters {
  device?: string | number | ReadonlyArray<string | number>;
  name?: string | ReadonlyArray<string>;
  priority?: string | number | ReadonlyArray<string | number>;
  source?: string | number | ReadonlyArray<string | number>;
  targets?: unknown;
}

export const eventService = {
  load(type: string, first: string, last: string) {
    const parts = ["", "api", "events", type];
    if (first) {
      parts.push(first);
      parts.push(last);
    }

    return baseService.get(parts.join("/"));
  },

  loadV3(start: string, end: string, filters: EventFilters) {
    const {
      targets,
      device: deviceId,
      name: eventName,
      priority: severity,
      source: sourceId,
    } = filters;

    return baseService.get("/api/events/v3", {
      ...(targets ? { targets } : {}),
      start,
      end,
      deviceId,
      eventName,
      severity,
      sourceId,
    });
  },
};

export default eventService;
